import request from "root/js/request";

export const getProductCostCheck = async ({ cabinet_id, shares_id, ...rest }) => {
  const response = await request({
    url: `/analytics/shares_products/cost_check/?cabinet_id=${cabinet_id}&shares_id=${shares_id}`,
    method: "get",
    params: {
      ...rest,
    },
  });
  return response.data;
};
